import { render } from "./theme13.vue?vue&type=template&id=6a130eea&scoped=true"
import script from "./theme13.vue?vue&type=script&lang=js"
export * from "./theme13.vue?vue&type=script&lang=js"

import "./theme13.vue?vue&type=style&index=0&id=6a130eea&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6a130eea"

export default script